import { render, staticRenderFns } from "./BigPowerLoading.vue?vue&type=template&id=25e3b87c&scoped=true"
import script from "./BigPowerLoading.vue?vue&type=script&lang=js"
export * from "./BigPowerLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3b87c",
  null
  
)

export default component.exports